import type { AiAppCenterModule } from '../types'

/** 后端 system_module.name=microscene；独立窗正式 key/path 为 scene */
export const microSceneModule: AiAppCenterModule = {
  key: 'scene',
  label: '微场景',
  desc: 'H5 场景 / 页面搭建 / 活动传播',
  path: '/scene',
  standalonePath: '/scene/dashboard',
  homePath: '/scene/dashboard',
  // 侧栏业务菜单仍挂在后端 /micro-scene、/microscene 下
  menuPaths: ['/micro-scene', '/microscene'],
  icon: 'ep:cellphone',
  color: '#6366f1',
  aliases: ['微场景H5', 'AI微场景']
}
